/**
 * External dependencies
 */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Box } from '@towersystems/towersystems-design-system';
import { compact } from 'lodash';

/**
 * Internal dependencies
 */
import Modal from 'components/modal';
import { isModalVisible } from 'state/ui/selectors';
import { stopMappingSalesTypes } from 'state/ui/sales-types-modal/actions';
import { getSalesTypeId } from 'state/ui/sales-types-modal/selectors';
import { getEditedConnectionSalesType } from 'state/connection-sales-types/selectors';
import SalesTypesForm from 'blocks/sales-types-form';
import { deleteConnectionSalesTypes } from 'state/connection-sales-types/actions';
import {successNotice} from 'state/notices/actions';

/**
 * Style dependencies
 */
import './styles.scss';

const EditSalesTypesModal = ({ salesTypeId, connectionSalesTypes, retailerSalesTypes, retailerPaymentTypes, webPaymentTypes, connectionId, connectionType, isVisible, disabled, close, onSuccess, onDeleted, ...props }) => {
    const [submitting, setSubmitting] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const isNew = !salesTypeId;
    const title = isNew ? 'Map sales type' : 'Update sales type mapping';

    const handleDelete = async () => {
        if (isNew) {
            return;
        }

        setDeleting(true);
        try {
            await props.deleteConnectionSalesTypes(salesTypeId);
            // props.successNotice("Deleted");
            // close();
            onDeleted();
        } catch (error) {}
        setDeleting(false);
    };

    const buttons = compact([
        {
            key: 'cancel',
            label: 'Cancel',
            onClick: close,
        },
        !isNew && {
            key: 'delete',
            label: deleting ? 'Deleting' : 'Delete',
            onClick: handleDelete,
        },
        {
            key: 'save',
            label: submitting ? 'Saving' : 'Save',
            form: 'sales-type-form',
            type: 'submit',
            disabled: submitting,
            primary: true,
        },
    ]);

    // const onSuccess = () => {
    //     close();
    //     props.successNotice('Saved');
    // }

    return (
        <Modal title={title} className='map-sales-type-modal' close={close} isVisible={isVisible} buttons={buttons} onSuccess={onSuccess}>
            <Box padding='xlarge'>
                <SalesTypesForm
                    salesTypeId={salesTypeId}
                    beforeSubmit={() => setSubmitting(true)}
                    afterSubmit={() => setSubmitting(false)}
                    afterSuccessfullSubmit={onSuccess}
                    connectionSalesTypes={connectionSalesTypes}
                    retailerSalesTypes={retailerSalesTypes}
                    retailerPaymentTypes={retailerPaymentTypes}
                    connectionId={connectionId}
                    connectionType={connectionType} 
                    webPaymentTypes={webPaymentTypes}
                />
            </Box>
        </Modal>
    );
};

export default connect(
    (state) => ({
        isVisible: isModalVisible('EditSalesTypesModal')(state),
        salesTypeId: getSalesTypeId(state),
        connectionSalesTypes: getEditedConnectionSalesType(state, getSalesTypeId(state)) || {},
    }),
    {
        close: stopMappingSalesTypes,
        deleteConnectionSalesTypes,
        successNotice
    },
)(EditSalesTypesModal);
